


























































import {Component, Vue, Prop} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import S3Image from '@/components/S3Image.vue';
import Card from '@/components/material/Card.vue';
import DlgSubscriptionsDelete from '@/modules/admin/subscriptions/_components/DlgSubscriptionsDelete.vue';
import DlgSubscriptionsEdit from '@/modules/admin/subscriptions/_components/DlgSubscriptionsEdit.vue';
import DlgSubscriptionsCreate from '@/modules/admin/subscriptions/_components/DlgSubscriptionsCreate.vue';

@Component({
  components: {
    DlgSubscriptionsCreate,
    DlgSubscriptionsEdit,
    DlgSubscriptionsDelete,
    Card,
    S3Image,
  },
})
export default class UsersList extends Vue {
  @Prop({type: String, default: ''}) private id!: string;

  @Action('admin/users/readOne') private readUser!: (id: string) => Promise<boolean>;
  @Action('admin/animals/read') private readAnimals!: () => Promise<boolean>;
  @Action('common/loader/addNavLoader') private startLoading!: () => null;
  @Action('common/loader/removeNavLoader') private stopLoading!: () => null;

  @Getter('admin/animals/all') private animals!: any;
  @Getter('admin/users/one') private one!: any;

  private loading: boolean = false;
  private headers: any = [
    {text: 'Last Payment', value: 'entry_date'},
    {text: 'ID', value: 'id'},
    {text: 'Deleted', value: 'deleted'},
    {text: 'Animal', value: 'animalId'},
    {text: 'Var Sym', value: 'var_sym'},
    {text: '', value: ''},
  ];

  private async mounted() {
    this.init();
  }

  private async init() {
    this.loading = true;
    this.startLoading();
    await this.readAnimals();
    await this.readUser(this.id);
    this.stopLoading();
    this.loading = false;
  }

  private getAnimal(id: string) {
    const filtered = this.animals.filter((animal) => animal.id === id)[0];

    if (filtered) {
      return `${filtered.title}${filtered.deleted ? ' (Deleted)' : ''}`;
    } else {
      return '- deleted -';
    }
  }
}
